import tenantApi from '@/api/tenant.api'


const state = {
  tenants: [],
  current: null
}


const getters = {
  tenants: (state) => {
    return state.tenants
  },

  currentTenant: (state) => {
    return state.current
  }
}


const actions = {
  async loadTenants ({ commit }) {
    const response = await tenantApi.getTenants()
    commit('SET_TENANTS', response.data)
    return response.data
  },

  setCurrentTenant ({ commit, state }, tenant) {
    if (!tenant && state.tenants.length) {
      tenant = state.tenants[0]
    }

    tenant = tenant || null

    commit('SET_CURRENT_TENANT', tenant)
    localStorage.setItem('currentTenant', JSON.stringify(tenant))
  },

  restoreCurrentTenant ({ commit }) {
    const json = localStorage.getItem('currentTenant')

    if (json) {
      const tenant = JSON.parse(json)
      commit('SET_CURRENT_TENANT', tenant)
    }
  }
}


const mutations = {
  SET_TENANTS (state, tenants) {
    state.tenants = tenants
  },

  SET_CURRENT_TENANT (state, tenant) {
    state.current = tenant.name
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
